/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { LegalDocument } from '../types';

export const privacyPolicy: LegalDocument = {
  "title": "プライバシーポリシー",
  "subtitle": "Koemori プライバシーポリシー",
  "effectiveDate": "制定日：2026年10月01日",
  "sections": [
    {
      "content": [
        "Meetune　Entertainment株式会社（以下「当社」といいます。）は、当社が提供するスマートフォン向けアプリケーション「Koemori」（以下「本サービス」といいます。）におけるユーザーの個人データの取扱いについて、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）その他関連法令に基づき、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。"
      ]
    },
    {
      "title": "事業者情報",
      "content": [
        "名称：Meetune Entertainment株式会社",
        "住所：〒150-0001　東京都渋谷区神宮前一丁目5番8号　神宮前タワービルディング12階",
        "代表者：代表取締役　王 金祥"
      ]
    },
    {
      "title": "取得する個人情報",
      "content": [
        "当社は、本サービスの提供・運営にあたり、以下の個人情報を取得する場合があります。"
      ],
      "subsections": [
        {
          "title": "1.1 ユーザー自身が提供する情報",
          "content": [
            "（1）アカウント作成時：氏名、ニックネーム、プロフィール画像、電話番号、メールアドレス、Apple・Google・X（旧Twitter）・LINEその他連携した第三者サービスのアカウント情報等",
            "（2）サービス利用・投稿時：歌唱音声データ、動画、画像、コメント等のテキストデータ、コラボ弾幕データ、ダイレクトメッセージ、お問い合わせ内容等"
          ]
        },
        {
          "title": "1.2 自動的に取得される情報",
          "content": [
            "端末識別情報、OS、ブラウザ、アプリバージョン、IPアドレス、アクセスログ、利用履歴、クラッシュログ、エラーログその他通信・技術情報"
          ]
        },
        {
          "title": "1.3 位置情報",
          "content": [
            "ユーザーの端末設定において位置情報の送信を許可した場合に取得される位置情報（GPS情報、Wi-Fi接続情報等）"
          ]
        },
        {
          "title": "1.4 連絡先情報",
          "content": [
            "ユーザーが明示的に許可した場合に限り、友達推薦等のソーシャル機能の提供を目的として取得される端末内の連絡先情報"
          ]
        }
      ]
    },
    {
      "title": "個人情報の利用目的",
      "content": [
        "当社は、取得した個人情報を以下の目的の範囲内で適切に利用します。",
        "（1）本サービスの提供、運営、保守および本人確認",
        "（2）楽曲の歌唱、録音、投稿、コラボ弾幕等、各種機能およびユーザー間交流機能の提供",
        "（3）レコメンド機能およびパーソナライズされたコンテンツの表示",
        "（4）お問い合わせ対応およびユーザーサポート",
        "（5）不正利用、アカウント乗っ取り、迷惑行為および法令違反行為の調査・防止",
        "（6）システムの保守、障害対応、品質改善および新機能の研究開発",
        "（7）広告配信、広告効果測定およびマーケティング分析",
        "（8）利用規約違反等への対応その他上記各号に付随する目的"
      ]
    },
    {
      "title": "AI機能に関する取扱い",
      "content": [
        "当社は、本サービスにおいてAI技術を利用した音声補正、ノイズ除去、音質改善等の機能（以下「AI機能」といいます。）を提供する場合があります。",
        "当社は、AI機能の提供、精度向上および技術の研究開発を目的として、ユーザーの音声データ等を匿名化または統計化したうえで利用することがあります。",
        "なお、ユーザーは本サービス内の設定機能（学習停止設定）を通じて、自己の音声データ等が新たにAIモデルの学習目的に利用されることを停止することができます。詳細は利用規約第7条（AI機能の使用）をご確認ください。"
      ]
    },
    {
      "title": "外部送信、Cookieおよび行動データの取り扱い",
      "content": [
        "当社は、本サービスおよび関連ウェブサイトにおいて、サービス改善、アクセス解析、ならびに第三者広告配信事業者（Google、Meta、TikTok等）を通じた最適な広告配信およびその効果測定を目的として、Cookieおよび類似の端末識別技術を利用して行動履歴等の情報を取得・外部送信する場合があります。",
        "ユーザーは、端末またはブラウザの設定によりCookie等の機能を無効化することができますが、その場合、本サービスの一部機能が利用できなくなる場合があります。"
      ]
    },
    {
      "title": "第三者への提供",
      "content": [
        "当社は、個人情報保護法その他の法令で認められる場合を除き、あらかじめユーザーの同意を得ることなく、個人データを第三者に提供しません。ただし、以下の場合は除きます。",
        "（1）法令に基づく場合",
        "（2）人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合",
        "（3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合",
        "（4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合",
        "（5）合併、会社分割、事業譲渡その他の事由により事業の承継が行われる場合",
        "2. 当社は、利用目的の達成に必要な範囲内において、個人データの取扱いの全部または一部を日本国内の業務委託先（サーバーの保守・運用会社、カスタマーサポート事業者等）に委託する場合があります。この場合、当社は、委託先に対して適切な監督および安全管理措置を義務付けるものとします。"
      ]
    },
    {
      "title": "安全管理措置および保有個人データの管理",
      "content": [
        "当社は、保有個人データの漏えい、滅失、毀損または不正アクセスを防止するため、以下のとおり必要かつ適切な安全管理措置を講じます。",
        "（1）組織的安全管理措置：個人情報取扱責任者の設置、安全管理規則の策定および社内運用体制の構築",
        "（2）人的安全管理措置：従業員に対する個人情報保護教育の定期的な実施および秘密保持義務の徹底",
        "（3）物理的安全管理措置：情報を取り扱う区域の入退出管理および情報機器等の盗難防止措置",
        "（4）技術的安全管理措置：アクセス権限の最小化、通信の暗号化（SSL/TLS）、不正アクセス防止用ファイアウォールの導入",
        "当社は、本サービスの運営に必要な範囲においてのみ個人情報を収集・利用し、利用目的の達成に必要な期間に限って適切に保管します。",
        "ユーザーは、当社が保有する自己の個人データについて、個人情報保護法に基づく開示、訂正、追加、削除または利用停止等を請求することができます。当社は、所定の本人確認を行ったうえで、法令に従い遅滞なく適切に対応します。",
        "なお、法令上の義務履行、紛争対応、不正利用防止その他正当な理由がある場合には、ユーザーから削除等の請求があった後も、一定期間関連情報を保持する場合があります。"
      ]
    },
    {
      "title": "未成年者の個人情報",
      "content": [
        "当社は、未成年者の個人情報の保護に配慮いたします。ユーザーが18歳未満の未成年者である場合、本サービスの利用（個人情報の登録等を含みます。）にあたり、あらかじめ親権者その他の法定代理人の同意を得るものとします。"
      ]
    },
    {
      "title": "外部サービスへのリンク",
      "content": [
        "本サービス内に含まれる第三者のウェブサイトやサービスへのリンク先における個人情報の取扱いについて、当社は責任を負いません。各リンク先のプライバシーポリシーをご確認ください。"
      ]
    },
    {
      "title": "お問い合わせ窓口",
      "content": [
        "個人情報の取扱いに関する苦情、ご相談および開示等のご請求は、以下の窓口までご連絡ください。",
        "Meetune Entertainment株式会社 個人情報取扱窓口",
        "住所：〒150-0001 東京都渋谷区神宮前一丁目5番8号 神宮前タワービルディング12階",
        "メールアドレス：koemori@meetune.com"
      ]
    },
    {
      "title": "本ポリシーの改定",
      "content": [
        "当社は、法令の改正またはサービス内容の変更等に応じて、本ポリシーを改定する場合があります。重要な変更がある場合は、本サービス内または公式サイトにて分かりやすい方法でお知らせします。"
      ]
    }
  ]
};

export const userAgreement: LegalDocument = {
  "title": "利用規約 Ver2.0",
  "subtitle": "Koemori 利用規約",
  "effectiveDate": "制定日：2026年10月1日\n最終改定日：2026年10月1日",
  "sections": [
    {
      "title": "第1条　総則",
      "content": [
        "本利用規約（以下「本規約」といいます。）は、Meetune Entertainment 株式会社（以下「当社」といいます。）が提供・運営するスマートフォン向けアプリケーション「Koemori」（以下「本サービス」といいます。）の利用に関する条件を定めるものであり、本サービスを利用するすべての利用者（以下「ユーザー」といいます。）と当社との間に適用されます。",
        "1. 本サービスは、ユーザーが楽曲を歌唱、録音、投稿し、他のユーザーとの交流、鑑賞、コラボ弾幕、メッセージ送信その他のコミュニケーションを楽しむことを目的とする、歌唱及び音声コミュニケーションサービスです。",
        "2. 当社は、本規約のほか、本サービスに関し、ガイドライン、ポリシー、コミュニティルール、個別規約その他のルール（以下総称して「個別規則」といいます。）を定める場合があります。",
        "3. 個別規則は、本規約の一部を構成するものとし、本規約と個別規則の内容が異なる場合には、個別規則に特段の定めがある場合を除き、本規約の定めが優先して適用されるものとします。",
        "4. 本規約は、本サービスの利用に関する当社とユーザーとの間の一切の権利義務関係に適用されます。",
        "5. 当社が本サービス内または当社ウェブサイト上で掲載する説明、案内、通知等は、本規約の補足として効力を有するものとします。"
      ]
    },
    {
      "title": "第2条　本規約への同意",
      "content": [
        "1. ユーザーは、本規約の内容を理解し、これに同意した場合に限り、本サービスを利用することができます。",
        "2. ユーザーがアカウント登録を行い、または実際に本サービスを利用した時点で、ユーザーは本規約に有効に同意したものとみなされます。",
        "3. 本サービスの一部機能について個別規則が定められている場合、ユーザーは本規約に加え、当該個別規則にも従うものとします。",
        "4. 当社は、民法第548条の4の規定に基づき、本規約を変更することができます。本規約を変更する場合、当社は、変更後の規約の効力発生時期および内容を、第16条の定めに従い、本サービス上での告知その他適切な方法によりユーザーに周知するものとします。変更後の規約の効力発生日以降にユーザーが本サービスを利用した場合、ユーザーは変更後の規約に同意したものとみなされます。"
      ]
    },
    {
      "title": "第3条　ユーザー資格",
      "content": [
        "1. ユーザーは、自らの責任において本サービスを利用するものとします。",
        "2. 未成年者が本サービスを利用する場合（有償サービスの購入を含みます。）、あらかじめ親権者その他の法定代理人（以下「法定代理人」といいます。）の同意を得たうえで本サービスを利用しなければなりません。",
        "3. 未成年者が、法定代理人の同意がないにもかかわらず同意があると偽って本サービスを利用した場合、または成年者と偽って本サービスを利用した場合その他民法第21条に定める詐術を用いた場合、本サービスに関する一切の法律行為を取り消すことはできません。",
        "4. 当社は、未成年者による有償サービスの購入に関して、年齢に応じた月額利用上限額その他の制限を設ける場合があります。",
        "5. 法人その他の事業者が本サービスを利用する場合、当該法人または事業者の正当な権限を有する者が本規約に同意したうえで利用するものとします。"
      ]
    },
    {
      "title": "第4条　アカウント",
      "content": [
        "1. ユーザーは、当社所定の方法に従い、本サービスのアカウント登録を行うものとします。",
        "2. ユーザーは、登録に際して、必要となる情報を真実かつ正確に提供しなければなりません。登録情報に変更が生じた場合には、速やかに更新するものとします。",
        "3. 当社は、本人確認、セキュリティ確保または法令遵守のために必要と判断した場合、ユーザーに対して追加情報または資料の提出を求めることができます。",
        "4. 当社は、以下のいずれかに該当すると判断した場合、アカウント登録を拒否し、または登録済みアカウントの利用を停止もしくは削除することができます。この場合、当社はその理由を開示する義務を負いません。",
        "（1）登録情報に虚偽、誤記または記載漏れがある場合",
        "（2）過去に本規約違反等により利用停止措置を受けた場合",
        "（3）反社会的勢力またはこれに準ずる者である場合",
        "（4）本サービスの運営を妨害するおそれがある場合",
        "（5）その他、当社が登録を不適切と判断した場合",
        "5. ユーザーは、自己の責任においてアカウント情報（ID、パスワードその他認証情報を含みます。）を適切に管理し、第三者に使用させ、貸与し、譲渡し、または売買してはなりません。",
        "6. アカウント情報の管理不十分、使用上の過誤または第三者の不正使用により生じた損害について、当社は故意または重過失がある場合を除き責任を負いません。",
        "7. 当社は、長期間利用実績のないアカウントについて、事前通知のうえまたは事前通知なく削除することができます。"
      ]
    },
    {
      "title": "第5条　退会",
      "content": [
        "1. ユーザーは、以下の各号のいずれかに定める方法により、いつでも本サービスの退会（アカウント削除）申請を行うことができます。",
        "（1）アプリケーション内からの申請：",
        "本サービスアプリ内の「設定」＞「アカウントとセキュリティ」画面において、対象のアカウントを選択のうえ、画面下部の「アカウント削除」を選択し、所定の案内に従い申請手続きを完了する方法。",
        "（2）ウェブサイトからの申請：",
        "当社公式ウェブサイト(https://www.meetune.com/)上の「FAQ」＞「アカウント関連」＞「アカウントの削除」ページより、所定の本人認証手続きを完了のうえ申請を行う方法。",
        "2. 前項に基づく退会申請が完了した場合、アカウントは退会猶予期間（30日間）に移行します。ユーザーが退会申請日から起算して30日以内に本サービスへの再ログインを行わなかった場合、当該期間の満了をもって、アカウントの削除および退会手続きが正式に完了するものとします。なお、当該期間内にユーザーが本サービスへ再ログインを行った場合、退会申請は撤回されたものとみなし、アカウントは従前の状態で維持されます。",
        "3. 退会時にユーザーが保有していた有償サービス、仮想通貨、ポイント、アイテムその他の一切の権利は、前項に定める退会手続きの完了をもって消滅し、返金、換金または他のアカウントへの引き継ぎ等は一切行われません。",
        "4. ユーザーが退会した場合であっても、退会前に他のユーザーの作品に対して投稿されたコラボ弾幕その他の投稿コンテンツは、本サービスの性質上、直ちに削除されない場合があるものとし、ユーザーはこれにあらかじめ同意するものとします。",
        "5. 退会手続きが完了した場合であっても、退会前の利用に起因して当社または第三者に対して負った一切の義務および責任は免除されません。"
      ]
    },
    {
      "title": "第6条　サービス提供",
      "content": [
        "1. 当社は、ユーザーに対し、本サービスを通じて、楽曲の検索、歌唱、録音、投稿、鑑賞、ユーザー間コミュニケーション、コラボ弾幕機能、有償コンテンツその他当社が提供する各種機能を提供します。",
        "2. ユーザーは、本サービスを利用するために必要なスマートフォン、通信機器、オペレーティングシステム、通信回線その他の設備（以下「利用設備」といいます。）を、自らの責任と費用において準備し、維持するものとします。",
        "3. 本サービスの利用に必要な通信料、データ通信費、電気料金その他一切の費用は、ユーザーの負担とします。",
        "4. 当社は、サービス品質の向上、法令対応、運営上の必要その他合理的な理由に基づき、ユーザーへの事前通知の有無を問わず、本サービスの全部または一部について、その仕様、機能、デザイン、提供方法その他一切の内容を追加、変更または削除することができます。",
        "5. 当社は、以下のいずれかの事由が生じた場合、ユーザーに事前に通知することなく、本サービスの全部または一部の提供を一時的に中断または停止することができます。",
        "（1）システム保守、点検、更新または障害対応を行う場合",
        "（2）通信回線、サーバーまたは外部サービスに障害が発生した場合",
        "（3）火災、停電、地震、洪水その他の不可抗力が発生した場合",
        "（4）その他当社が運営上必要と判断した場合",
        "6. 当社は、前項に基づくサービスの中断または停止によりユーザーに生じた損害について、当社に故意または重過失がある場合を除き、一切責任を負いません。"
      ]
    },
    {
      "title": "第7条　AI機能の使用",
      "content": [
        "1. ユーザーは、本サービスを通じて、楽曲を歌唱し、音声作品（以下「作品」といいます。）を録音、編集、保存および投稿することができます。",
        "2. 当社は、本サービスにおいて、音声品質の向上、歌唱体験の改善その他サービス品質向上を目的として、人工知能（AI）技術その他の音声処理技術を利用した機能（以下「AI機能」といいます。）を提供する場合があります。AI機能には、AIによる音声補正、ノイズ除去、音質改善その他これらに類する処理が含まれますが、これらに限られません。",
        "3. ユーザーは、AI機能を利用するにあたり、当社がユーザーの音声データ、作品データおよび関連メタデータを解析、処理または変換することに同意するものとします。",
        "4. 当社は、AI機能の精度向上、アルゴリズム改善、モデルの高度化、研究開発その他サービス改善を目的として、法令に従い、必要な範囲でユーザーの音声データ、作品データまたはその特徴量を、匿名化または個人を識別できない形式に加工したうえで、AIモデルの学習または検証に利用することがあります。",
        "5. 当社は、ユーザーの明示的な同意なく、ユーザーの音声データ、作品データまたはその特徴量を用いて、特定のユーザーを識別可能な音声モデル、音声クローン、声質模倣モデルその他これらに類するモデルを生成または提供しません。",
        "6. ユーザーは、当社所定の方法により、自己の音声データまたは作品データのAIモデル学習への利用を停止する設定（以下「学習停止設定」といいます。）を行うことができます。当社は、ユーザーが学習停止設定を有効化した後、新たに取得される対象データについて、AIモデルの学習目的での利用を停止します。",
        "7. 前項の学習停止設定は、設定変更以前に既に実施されたAIモデルの学習、検証またはこれに基づいて生成されたモデル、アルゴリズムもしくは統計情報には遡及して適用されないものとします。",
        "8. ユーザーは、AI機能による処理結果が機械学習モデルその他自動処理技術に基づいて生成されるものであり、その結果について完全性、正確性、有用性またはユーザーの期待との一致が保証されないことをあらかじめ了承するものとします。",
        "9. 当社は、AI機能による音声補正、分析または生成結果に起因してユーザーに生じた損害について、当社に故意または重過失がある場合を除き、一切責任を負いません。"
      ]
    },
    {
      "title": "第8条　コラボ弾幕機能",
      "content": [
        "1. 本サービスには、ユーザーが他のユーザーの公開作品に対して、自らの歌唱または音声をコーラス弾幕として投稿し、当該作品に重ねて再生できる機能（以下「コラボ弾幕機能」といいます。）が含まれます。",
        "2. コラボ弾幕として投稿された音声データは、第11条に定める投稿コンテンツの一部として取り扱われるものとします。",
        "3. ユーザーがコラボ弾幕を投稿した場合、当該ユーザーは、当社に対し、当該音声データについて、保存、複製、変換、圧縮、音量調整、同期再生、混音その他本サービスの運営上必要な処理を行うことを無償で許諾するものとします。",
        "4. コラボ弾幕が他のユーザーに公開されるか否かは、原作品を投稿したユーザー（以下「原作品投稿者」といいます。）の承認その他当社が定める条件に従うものとします。",
        "5. 原作品投稿者は、自らの作品に投稿されたコラボ弾幕について、表示、非表示、削除その他当社が提供する範囲で管理することができます。",
        "6. コラボ弾幕を投稿したユーザーは、自己の投稿したコラボ弾幕が、原作品と一体的に再生され、他のユーザーによって繰り返し視聴される場合があることをあらかじめ了承するものとします。",
        "7. 原作品が削除された場合、非公開化された場合、または原作品投稿者もしくはコラボ弾幕投稿者のアカウントが削除もしくは利用停止となった場合、当社は関連するコラボ弾幕の全部または一部を削除、非表示化または利用停止とすることができます。",
        "8. 当社は、法令、本規約または運営上の必要に基づき、事前通知なくコラボ弾幕の投稿、表示または再生を制限または停止することができます。"
      ]
    },
    {
      "title": "第9条　禁止事項",
      "content": [
        "1. ユーザーは、本サービスの利用にあたり、以下の各号に該当する行為またはそのおそれのある行為を行ってはなりません。",
        "（1）法令、公序良俗または本規約に違反する行為",
        "（2）犯罪行為、犯罪の予告、犯罪の助長、詐欺、脅迫、恐喝、マネーロンダリングその他これらに類する行為",
        "（3）当社または第三者の著作権、商標権、特許権、肖像権、プライバシー権、名誉権その他の権利または利益を侵害する行為",
        "（4）虚偽情報の登録、第三者へのなりすまし、他人のアカウントの不正利用その他不正な身分偽装行為",
        "（5）以下の内容を含むコンテンツを投稿、送信、表示または共有する行為",
        "① 過度に暴力的、残虐またはグロテスクな内容",
        "② わいせつ、性的搾取または性的羞恥を伴う内容",
        "③ 児童虐待、児童性的搾取または児童ポルノに該当する内容",
        "④ 自殺、自傷行為、薬物乱用、危険行為を助長する内容",
        "⑤ 差別、偏見、ヘイトスピーチまたは嫌がらせに該当する内容",
        "（6）営利目的の広告、宣伝、勧誘、営業活動、宗教活動またはこれに類する行為（当社が認める場合を除きます）",
        "（7）他のユーザーに対する嫌がらせ、ストーキング、執拗な接触、迷惑行為、私信機能を利用した不適切な接触行為、または面識のない異性との性交、わいせつな行為、出会いその他交際を主たる目的として本サービスを利用する行為",
        "（8）コラボ弾幕機能、コメント機能またはメッセージ機能を用いて、他のユーザーに不快感、精神的負担または迷惑を与える行為",
        "（9）BOT、チートツール、自動化スクリプト、エミュレーターその他技術的手段を用いて、本サービスを不正に操作する行為",
        "（10）再生数、いいね数、ランキング、人気度、ギフト数その他本サービス内の評価指標を、人為的または不正な方法で操作する行為",
        "（11）複数アカウントの不正利用、アカウント売買、貸与、譲渡またはこれらに準ずる行為",
        "（12）AI機能を不正に利用し、虚偽の歌唱結果を生成し、ランキング操作その他不正な利益を得る行為",
        "（13）本サービス内の仮想通貨、ギフト、ポイントまたは有償コンテンツを、本サービス外の金銭、財物または経済的利益と交換する行為",
        "（14）本サービスの運営を妨害し、または当社の信用を毀損する行為",
        "（15）その他、当社が不適切と合理的に判断する行為",
        "2. 当社は、ユーザーが前項の禁止事項に違反し、または違反するおそれがあると判断した場合、事前通知なく、投稿コンテンツの削除、機能制限、アカウント停止その他必要な措置を講じることができます。",
        "3. 当社は、前項の措置に関する判断理由を開示する義務を負いません。"
      ]
    },
    {
      "title": "第10条　反社会的勢力の排除",
      "content": [
        "1. ユーザーは、現在かつ将来にわたり、自己が暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ、特殊知能暴力集団等その他これらに準ずる者（以下総称して「反社会的勢力」といいます。）に該当しないこと、および暴力的な要求行為、法的な責任を超えた不当な要求行為等の反社会的行為を行わないことを確約するものとします。",
        "2. ユーザーが前項に違反した場合、当社は事前の通知または催告を要することなく、直ちに当該ユーザーのアカウントの停止、削除その他本サービスの利用停止措置を講じることができるものとし、これにより当該ユーザーに生じた損害について一切責任を負いません。"
      ]
    },
    {
      "title": "第11条　投稿コンテンツ",
      "content": [
        "1. ユーザーは、本サービスを通じて、作品、コラボ弾幕、コメント、メッセージ、プロフィール情報、画像、音声、動画その他当社が指定するコンテンツ（以下総称して「投稿コンテンツ」といいます。）を投稿、送信、保存または公開することができます。",
        "2. ユーザーは、自らが投稿、送信または公開した投稿コンテンツについて、一切の責任を負うものとし、当該投稿コンテンツが法令、本規約または第三者の権利を侵害しないことを保証するものとします。",
        "3. ユーザーは、投稿コンテンツの投稿または送信に必要な権利を適法に保有し、または必要な権利者の許諾を得ていることを保証するものとします。",
        "4. ユーザーは、投稿コンテンツに第三者の著作物、肖像、氏名、音声その他第三者の権利または利益に関わる内容が含まれる場合、当該投稿について必要な同意、許可または権利処理を完了しているものとします。",
        "5. 以下のいずれかに該当し、または該当するおそれがある投稿コンテンツについて、当社は事前通知なく、その全部または一部を削除、非表示化、公開停止またはアクセス制限することができます。",
        "（1）第9条に定める禁止事項に違反するもの",
        "（2）法令または公序良俗に反するもの",
        "（3）第三者の権利または利益を侵害するもの",
        "（4）虚偽または誤認を招く内容を含むもの",
        "（5）当社が運営上不適切と合理的に判断するもの",
        "6. 当社は、投稿コンテンツについて、法令上または運営上必要な範囲で審査、監視または確認を行う場合がありますが、すべての投稿コンテンツについて監視または審査を行う義務を負うものではありません。",
        "7. 当社は、投稿コンテンツの保存、バックアップまたは復元を保証するものではなく、ユーザーは必要に応じて自己の責任で投稿コンテンツを保存または管理するものとします。",
        "8. 法令、裁判所、行政機関その他権限ある機関から適法な要請があった場合、当社は法令に従い投稿コンテンツを開示、提出または提供することがあります。",
        "9. 第三者から、投稿コンテンツが自己の権利を侵害している旨の申出があった場合、当社は、当社の裁量により、当該投稿コンテンツを事前の通知なく削除、非表示化または利用制限することができます。当社は、かかる措置によりユーザーに生じた損害について、一切の責任を負いません。"
      ]
    },
    {
      "title": "第12条　知的財産権",
      "content": [
        "1. 本サービスを構成するプログラム、ソフトウェア、システム、デザイン、画面レイアウト、ロゴ、商標、キャラクター、楽曲伴奏、効果音、画像、文章その他本サービスに関する一切のコンテンツ（投稿コンテンツを除きます。）に係る著作権、商標権その他一切の知的財産権は、当社または正当な権利を有する第三者に帰属します。",
        "2. 本規約に基づく本サービスの利用許諾は、本サービスに関する知的財産権その他の権利をユーザーに譲渡し、または使用許諾するものではありません。",
        "3. 投稿コンテンツに係る著作権その他の知的財産権は、当該投稿コンテンツを作成したユーザーまたは正当な権利者に留保されるものとします。",
        "4. ユーザーは、投稿コンテンツを本サービスへ投稿した時点で、当社に対し、当該投稿コンテンツを本サービスの提供、運営、保守、改善、品質向上、プロモーション、広告宣伝、マーケティングその他本サービスに関連する目的のために、世界中において、無償で、非独占的に利用する権利（複製、公衆送信、表示、配信、翻訳、編集、要約、変換、トリミング、サムネイル化その他必要な利用を含みます。）を許諾するものとします。",
        "5. 前項の利用には、投稿コンテンツをサービス内外の広報資料、広告、キャンペーン、SNS、アプリストアその他本サービスの紹介または宣伝に利用することを含みます。",
        "6. 当社は、投稿コンテンツの内容または趣旨を変更しない範囲において、表示形式の変更、ファイル形式の変換、音量調整、画質または音質の最適化その他技術上必要な加工を行うことができます。",
        "7. コラボ弾幕については、その著作権は当該コラボ弾幕を投稿したユーザーに帰属します。ただし、コラボ弾幕が原作品と同期して再生されるために必要な利用については、第4項の許諾に加え、原作品との組み合わせによる利用を当社および原作品投稿者に対して許諾するものとします。",
        "8. ユーザーは、当社または当社から適法に権利の許諾もしくは再許諾を受けた第三者に対し、第4項から第7項に定める本サービスの運営、改善、品質向上、プロモーション等に必要な範囲において、投稿コンテンツに関する著作者人格権（同一性保持権、氏名表示権等を含みます。）を行使しないものとします。",
        "9. ユーザーは、投稿コンテンツが第三者の権利を侵害したことにより生じた紛争について、自らの責任と費用において解決するものとし、当社に損害を与えた場合には、その損害を賠償するものとします。",
        "10. 本サービス内で提供される楽曲の伴奏音源および歌詞データ等（以下「提供音源等」といいます。）に関する著作権その他の権利は、当社または当社に利用を許諾した権利者（著作権等管理事業者を含みます。）に帰属します。ユーザーは、提供音源等を本サービス内において歌唱、録音および投稿する目的に限って利用できるものとし、当社の事前の書面による承諾なく、提供音源等を複製、リバースエンジニアリング、抽出、転載、または本サービス外で配信、販売、譲渡その他の利用をしてはなりません。"
      ]
    },
    {
      "title": "第13条　有償サービス",
      "content": [
        "1. 本サービスでは、有償会員サービス、仮想通貨、ギフトその他当社が別途定める有償コンテンツ（以下「有償サービス」といいます。）を提供する場合があります。",
        "2. 有償サービスの内容、販売価格、利用条件、提供期間その他の詳細については、本サービス内の表示または当社が別途定める方法によるものとします。",
        "3. 有償サービスの購入代金は、ユーザーが利用するアプリストアその他当社が指定する決済方法に従って支払うものとします。",
        "4. 有償会員サービスが定期購入方式で提供される場合、ユーザーが所定の方法により更新日前までに解約手続きを行わない限り、契約は同一条件で自動的に更新されます。",
        "5. ユーザーは、各アプリストアの定める方法に従って、有償会員サービスの解約または自動更新の停止手続きを行うものとします。",
        "6. 有償サービスの利用期間が終了した場合、ユーザーは当該有償サービスに付随する特典を利用することができなくなります。ただし、利用期間終了前に取得した仮想通貨その他当社が別途定めるものについては、この限りではありません。",
        "7. 資金決済に関する法律その他法令に別段の定めがある場合を除き、一度購入または決済が完了した有償サービス（同法に基づく前払式支払手段に該当する仮想通貨等を含みます。）について、当社は理由の如何を問わず返金、交換、換金または取消しを行いません。本サービスが終了した場合における前払式支払手段の払戻しについては、同法および当社が別途定める手続きに従うものとします。",
        "8. 仮想通貨、ギフトその他のデジタルアイテムは、本サービス内でのみ利用することができ、現金その他の財産的価値との交換、第三者への譲渡、貸与または換金を行うことはできません。",
        "9. 当社は、法令の改正、運営上の必要その他合理的な理由がある場合、有償サービスの内容、価格または提供方法を変更し、または提供を終了することができます。"
      ]
    },
    {
      "title": "第14条　個人情報の取り扱い",
      "content": [
        "1. 当社は、ユーザーの個人情報を、別途定める「プライバシーポリシー」に従い、適切に取得、利用、管理および保護します。",
        "2. ユーザーは、本サービスを利用することにより、当社がプライバシーポリシーに定める目的および方法に従って個人情報を取り扱うことに同意したものとみなされます。",
        "3. 当社は、本サービスの提供、運営、保守、本人確認、不正利用防止、お問い合わせ対応その他本サービスの運営に必要な範囲で、ユーザーの個人情報を利用することがあります。",
        "4. AI機能に関するデータの取扱いについては、第7条（音声作品及びAI機能）およびプライバシーポリシーの定めに従うものとします。",
        "5. 個人情報の取得項目、利用目的、第三者提供、安全管理措置その他個人情報の取扱いに関する詳細は、プライバシーポリシーによるものとします。"
      ]
    },
    {
      "title": "第15条　免責事項",
      "content": [
        "1. 当社は、本サービスについて、その完全性、正確性、有用性、安全性、継続性、特定の目的への適合性その他一切の事項について保証するものではありません。",
        "2. 当社は、本サービスの提供、中断、停止、変更、終了または本サービスを利用できなかったことによりユーザーに生じた損害について、当社に故意または重過失がある場合を除き、一切責任を負いません。",
        "3. 当社は、通信回線、端末設備、外部サービス、第三者サービスその他当社の管理が及ばない事由により本サービスの全部または一部が利用できなかった場合について責任を負いません。",
        "4. 当社は、ユーザー間またはユーザーと第三者との間で生じた紛争について、一切関与せず、責任を負いません。",
        "5. 天災、戦争、暴動、テロ、停電、通信障害、システム障害、サイバー攻撃その他当社の合理的な支配を超える事由（不可抗力）により本サービスの提供が困難となった場合、当社はこれによって生じた損害について責任を負いません。",
        "6. 何らかの理由により当社がユーザーに対して損害賠償責任を負う場合（消費者契約法の適用がある場合を含みます。）であっても、当社に故意または重大な過失がある場合を除き、当社の賠償責任は、ユーザーに現実かつ直接に生じた通常損害の範囲に限られるものとし、かつ、付随的損害、間接損害、特別損害、将来の損害および逸失利益にかかる損害については賠償責任を負わないものとします。また、この場合における賠償額は、損害の事由が生じた日の属する月に当該ユーザーが当社に対して支払った利用料金の総額（有償サービスの購入額を含みます。）または10,000円のいずれか高い額を上限とします。"
      ]
    },
    {
      "title": "第16条　本規約の変更",
      "content": [
        "1. 当社は、法令の改正、本サービスの内容の変更、運営上の必要その他合理的な理由がある場合、本規約を変更することができます。",
        "2. 当社は、本規約を変更する場合、変更後の内容および効力発生日を、本サービス内または当社ウェブサイトへの掲載その他当社が適当と判断する方法によりユーザーへ通知します。",
        "3. 変更後の本規約は、当社が別途定める場合を除き、前項の通知において定める効力発生日から効力を生じるものとします。",
        "4. ユーザーが本規約の変更後も本サービスを継続して利用した場合、当該ユーザーは変更後の本規約に同意したものとみなされます。"
      ]
    },
    {
      "title": "第17条　連絡および通知",
      "content": [
        "1. 本サービスに関する当社からユーザーへの連絡または通知は、本サービス内の適宜の場所への掲示、プッシュ通知、登録されたメールアドレスへの送信その他当社が適当と判断する方法により行います。",
        "2. 当社が登録メールアドレスへの送信その他の電子的な方法により通知を行った場合、当社が通知を発信した時点で、当該通知はユーザーに到達したものとみなします。",
        "3. ユーザーが本サービスに関する問い合わせまたは連絡を当社に行う場合は、本サービス内のお問い合わせフォームその他当社が指定する方法によるものとします。"
      ]
    },
    {
      "title": "第18条　権利義務の譲渡禁止",
      "content": [
        "1. ユーザーは、当社の書面による事前の承諾なく、本規約に基づく契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。",
        "2. 当社が本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利および義務ならびにユーザーの登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項においてあらかじめ同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。"
      ]
    },
    {
      "title": "第19条　分離可能性",
      "content": [
        "本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定および一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。"
      ]
    },
    {
      "title": "第20条　準拠法・管轄裁判所",
      "content": [
        "1. 本規約の成立、効力、解釈および本サービスの利用に関しては、日本法を準拠法とします。",
        "2. 本サービスまたは本規約に関連して、当社とユーザーとの間に紛争が生じた場合、当社の本店所在地を管轄する簡易裁判所または地方裁判所を第一審の専属的合意管轄裁判所とします。"
      ]
    },
    {
      "content": [
        "Meetune Entertainment 株式会社"
      ]
    }
  ]
};

export const commercialDisclosure: LegalDocument = {
  "title": "特定商取引法に基づく表記",
  "subtitle": "特定商取引法に基づく表記",
  "effectiveDate": "",
  "sections": [
    {
      "title": "サービス提供事業者",
      "content": [
        "Meetune Entertainment株式会社"
      ]
    },
    {
      "title": "代表者",
      "content": [
        "代表取締役 王 金祥"
      ]
    },
    {
      "title": "所在地",
      "content": [
        "〒150-0001",
        "東京都渋谷区神宮前一丁目5番8号 神宮前タワービルディング12階"
      ]
    },
    {
      "title": "お問い合わせ先",
      "content": [
        "連絡先電話番号：03-6741-7221",
        "受付時間：平日 11:00〜13:00、15:00～18:00",
        "メールアドレス：koemori@meetune.com"
      ]
    },
    {
      "title": "サービス内容",
      "content": [
        "スマートフォン向けアプリケーション「Koemori」の提供、同アプリ内における有料会員サービス（サブスクリプション）、およびアプリ内仮想通貨・デジタルアイテム等の提供"
      ]
    },
    {
      "title": "販売価格",
      "content": [
        "・アプリ本体：無料",
        "・有料会員サービス（定期購入）：対象プランごとにアプリ内の購入画面に表示される価格（消費税込み）",
        "・アプリ内仮想通貨・アイテム：対象アイテムごとにアプリ内の購入画面に表示される価格（消費税込み）",
        "※詳細はアプリ内の各購入・決済画面をご確認ください。"
      ]
    },
    {
      "title": "販売価格以外の費用",
      "content": [
        "・インターネット接続料金",
        "・インターネット接続料金、パケット通信料その他通信回線の利用に伴う費用等",
        "・その他、本サービスの利用に必要な費用",
        "※通信料金等は、お客様が契約する通信事業者の料金体系によります。"
      ]
    },
    {
      "title": "支払い方法",
      "content": [
        "・Apple App Store 決済",
        "・Google Play 決済",
        "・クレジットカード決済"
      ]
    },
    {
      "title": "支払い時期",
      "content": [
        "・有料会員サービス：有料会員サービスは定期購入サービスです。初回購入手続き完了時に決済が行われ、以降は契約期間の満了に伴い自動的に更新され、所定のサイクルで都度決済されます",
        "・その他有料サービス：購入時に即時決済されます。"
      ]
    },
    {
      "title": "サービス提供時期",
      "content": [
        "決済手続完了後、直ちにご利用いただけます。"
      ]
    },
    {
      "title": "返品・キャンセルについて",
      "content": [
        "1. デジタルコンテンツおよびサービスの特性上、購入手続完了後のキャンセル、返品、交換または返金には応じられません（法令に特段の定めがある場合を除きます）。",
        "2. 有料会員サービス（定期購入）の解約は、ご利用の端末（App Store、Google Play等のアカウント設定画面）よりいつでもお手続きいただけます。",
        "3. 次回更新日の24時間前（または各ストアが指定する期日）までに解約手続きを行わない限り、自動的に契約が更新されます。",
        "4. 契約期間の途中で解約された場合であっても、日割り計算による返金や精算は行われません（契約満了日まで引き続きサービスをご利用いただけます）。"
      ]
    },
    {
      "title": "不具合・契約不適合に関する責任",
      "content": [
        "提供するデジタルコンテンツまたはサービスに重大な瑕疵または不具合があった場合、当社は速やかに修正・改修に努めますが、デジタルコンテンツの性質上、現状有姿での提供となり、個別での返金等には応じかねます。"
      ]
    },
    {
      "title": "推奨環境",
      "content": [
        "iOS 15.0以上 / Android 10.0以上",
        "※上記環境を満たしている場合でも、端末や通信環境により正常に動作しない場合があります。"
      ]
    },
    {
      "title": "知的財産権について",
      "content": [
        "本サービス上で提供される音楽コンテンツ、音声、画像、映像、プログラムその他一切のコンテンツに関する著作権その他知的財産権は、当社または正当な権利を有する第三者に帰属します。",
        "ユーザーは、当社または権利者の許可なく、これらを複製、転載、配布、改変その他法令で認められる範囲を超えて利用することはできません。"
      ]
    }
  ]
};
